class NavigationMenu {
  constructor(configs) {
    this.configs = configs;
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;

    this.mobileWidth = 1280;
    this.transitionMS = 700;

    this.isMobileSearchAvailable = this.configs.isMobileSearchAvailable === "true";
    this._setupEventListeners();
  }

  _isMobile() {
    return window.innerWidth < this.mobileWidth;
  }

  _isIPhoneOrIPad = () => window.navigator.userAgent.match(/iPad/i) || window.navigator.userAgent.match(/iPhone/i);

  _getElements() {
    const container = document.querySelector(this.configs.selectors.navigationMenu);
    return container ? {
      container,
      header: document.querySelector(this.configs.selectors.header),
      body: document.querySelector(this.configs.selectors.body),
      menuItemsThatHasChild: container.querySelectorAll(this.configs.selectors.menuItemsThatHasChild),
      secondLevelBackToFirstLevel: container.querySelectorAll(this.configs.selectors.secondLevelBackToFirstLevel)
    } : {};
  }

  _setupEventListeners() {
    const isMobile = this._isMobile();
    const isIPhoneOrIPad = this._isIPhoneOrIPad();

    this.elements.container.addEventListener('mouseover', this._onMouseOverHandle.bind(this));
    this.elements.container.addEventListener('mouseout', this._onMouseOutHandle.bind(this));

    if (isMobile) {
      this.elements.container.addEventListener('click', this._onClickOrTouch.bind(this));
      isIPhoneOrIPad && this.elements.container.addEventListener('touchstart', this._onClickOrTouch.bind(this));
    }
  }

  _onMouseOutHandle(e) {
    const childMenuOpener = e.target.closest("li[data-id]");
    let closeToHeader;
    if(childMenuOpener) {
      childMenuOpener.removeAttribute('open');
      closeToHeader = e.toElement && e.toElement.closest(this.configs.selectors.header);
      e.stopPropagation();
      if(!closeToHeader) {
        setTimeout(() => {
          this.elements.body.classList.remove(this.configs.classes.transparentHeader);
        }, 0);
      } 
    }
  }

  _onMouseOverHandle(e) {
    const childMenuOpener = e.target.closest('li[data-id]');
    
    if(childMenuOpener) {
      childMenuOpener.setAttribute('open', '');
    }
  }

  _onClickOrTouch(e) {
    const childMenuOpener = e.target.closest('li[data-id]');
    const secondLevelBackToFirstLevel = e.target.closest('.' + this.configs.classes.secondLevelBackToFirstLevel);

    if(secondLevelBackToFirstLevel || (childMenuOpener && !childMenuOpener.classList.contains(this.configs.classes.childMenuActive))) {
      e.preventDefault();
      childMenuOpener.classList.toggle(this.configs.classes.childMenuActive);
    }

    if(secondLevelBackToFirstLevel) {
      secondLevelBackToFirstLevel.nextElementSibling.scrollTo({
        top: 0
      })
    }
  }

  _handleAddClassesToBody = () => {
    this.elements.body.classList.add(this.configs.classes.transparentHeader);
  }

  _handleRemoveClassesFromBody = () => {
    this.elements.body.classList.remove(this.configs.classes.transparentHeader);
  }
}
